<template>
    <div class="fv-plugins-icon-container">
        <!--begin::Label-->
        <label class="d-flex align-items-center fs-5 fw-bold">
            <span>{{localValue.parish}}</span>
        </label>
        <!--end::Label-->
        <!--begin::Input-->
        <input
            type="number"
            class="form-control form-control-lg form-control-solid"
            v-model.number="localValue.cost"
        />
        <!--end::Input-->
        <div class="fv-plugins-message-container invalid-feedback"></div>
        <div class="d-flex justify-content-center">

        <button
            @click="updateCost"
            class="btn fw-bold px-6 py-5 w-10 mb-4 mt-6 btn-primary"
        >
            Update
        </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value:{
                id: {
                    type: String,
                    required: true,
                    default: ""
                },
                parish: {
                    type: String,
                    required: true,
                    default: ""
                },
                cost: {
                    type: Number,
                    required: true,
                    default: 0
                }
            }
        },
        watch: {
            localValue: {
                handler(newVal) {
                    this.$emit("input", newVal);
                },
                deep: true
            }
        },
        computed: {
            localValue: {
                get() {
                    return this.value;
                }
            },
        },
        methods: {
            updateCost() {
                this.$emit("updateDeliveryCost", {id: this.localValue.id, parish: this.localValue.parish, cost: this.localValue.cost});
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>